# Light list of the proposals of a link waiting for the logged reviewer: without
# `affectedDimensions` and `changes` the backend does not compute the diff. Used for the orange dot
# of the group calendar header.
query assignmentProposalsForReviewIds($scenarioId: ID!, $originId: ID!, $linkId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    assignmentProposalsForReview(linkId: $linkId) {
      errorCode
      proposals {
        id
        __typename
      }
      __typename
    }
    __typename
  }
}
